import { useState, useEffect, useMemo } from "react";
import { notistackService } from "../dependencyInjection";
import { unsubscribe } from "../../../../utils";
import { SnackbarParam, NotificationsType } from "../services/NotistackService";
import { OptionsObject } from "notistack";

type UseRemoveSnackbar = (note: OptionsObject["key"]) => void;
type UseCreateSnackbar = (snackbarParam: SnackbarParam) => void;
type UseNotistackResult = [NotificationsType[], UseCreateSnackbar, UseRemoveSnackbar];

export function useNotistack(): UseNotistackResult {
  const [notifications, setNotifications] = useState<NotificationsType[]>([]);

  useEffect(() => {
    const sub = notistackService.notifications$.subscribe((notific) => {
      setNotifications(notific);
    });
    return unsubscribe(sub);
  }, []);

  const createSnackbar = useMemo(
    () => (snackbarParam: SnackbarParam) => {
      notistackService.createSnackbar(snackbarParam);
    },
    [],
  );

  const removeSnackbar = useMemo(
    () => (note: OptionsObject["key"]) => {
      notistackService.removeSnackbar(note);
    },
    [],
  );

  return [notifications, createSnackbar, removeSnackbar];
}
